// extracted by mini-css-extract-plugin
export default {"header":"Messages-module__header__UgFMw","departmentFilter":"Messages-module__departmentFilter__wl3Th"};